/**
 * @module app.loadingspinner
 */

class Controller {
  /**
   * @param {!angular.Scope} $scope
   * @param {!angular.$timeout} $timeout
   * @ngInject
   */
  constructor($scope, $timeout) {
    /**
     * @export
     * @type {boolean}
     */
    this.isLoading;

    /**
     * @export
     * @type {boolean}
     */
    this.showSpinner = false;

    /**
     * @private
     * @type {angular.$q.Promise}
     */
    this.cancelPromise_;

    $scope.$watch(() => this.isLoading, (isLoading) => {
      if (isLoading) {
        this.cancelPromise_ = $timeout(() => {
          this.showSpinner = true;
        }, 500);
      } else {
        if (this.cancelPromise_) {
          $timeout.cancel(this.cancelPromise_);
        }
        this.showSpinner = false;
      }
    });
  }
}

/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'isLoading': '<',
  },
  controller: Controller,
  templateUrl: 'partials/loadingspinner.html'
};

export default angular.module('appLoadingspinner', []).component('appLoadingspinner', component);
